import { EChatImagesActionTypes, TAddChatImagesPayload, TChatImagesPayload, TChatImagesSucceedPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Состояние загрузки изображений
 */
export const setChatImagesPending = actionGenerator<EChatImagesActionTypes.SetChatImagesPending, TChatImagesPayload>(
  EChatImagesActionTypes.SetChatImagesPending,
);

/**
 * Успешная загрузка изображений
 */
export const setChatImagesSucceed = actionGenerator<
  EChatImagesActionTypes.SetChatImagesSucceed,
  TChatImagesSucceedPayload
>(EChatImagesActionTypes.SetChatImagesSucceed);

/**
 * Ошибка загрузки изображений
 */
export const setChatImagesFailed = actionGenerator<EChatImagesActionTypes.SetChatImagesFailed, TChatImagesPayload>(
  EChatImagesActionTypes.SetChatImagesFailed,
);

/**
 * Обнуление поля с изображениями
 */
export const setChatImagesEmpty = actionGenerator<EChatImagesActionTypes.SetChatImagesEmpty, TChatImagesPayload>(
  EChatImagesActionTypes.SetChatImagesEmpty,
);

/**
 * Локальное добавление изображений в галерею чата
 */
export const addChatImages = actionGenerator<EChatImagesActionTypes.AddChatImages, TAddChatImagesPayload>(
  EChatImagesActionTypes.AddChatImages,
);
